// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"c8398ee8","306":"74c6f52c","668":"ed201bf1"}[chunkId] + ".chunk.css";
};